import React from 'react';
import { useModal } from '../../context/ModalContext';
import './ApplicationForm.css';

const reasons = [
  {
    icon: '🎯',
    title: 'Score-Based Matching',
    desc: 'We analyse your NEET score, budget, and goals to shortlist only the colleges where you have the best chance of admission.',
    color: 'blue',
  },
  {
    icon: '🌍',
    title: 'Global College Network',
    desc: 'Access 50+ NMC-approved partner universities across Russia, Philippines, Kazakhstan, Georgia and more — all verified by our experts.',
    color: 'sky',
  },
  {
    icon: '📋',
    title: 'End-to-End Support',
    desc: 'From application to accommodation booking and pre-departure briefing — we handle every step so you can focus on studying.',
    color: 'green',
  },
  {
    icon: '⚡',
    title: '24-Hour Expert Callback',
    desc: 'Submit your details and a dedicated MBBS counsellor will call you within 24 hours with a personalised roadmap — completely free.',
    color: 'orange',
  },
  {
    icon: '🔒',
    title: '100% Free & Confidential',
    desc: 'Our counselling is zero-cost to students. We are compensated by our partner institutions, not by you. Your data is never sold.',
    color: 'purple',
  },
  {
    icon: '🏆',
    title: '6+ Years of Experience',
    desc: 'Since 2019, we have helped over 2,500 students secure seats in top medical colleges. Our track record speaks for itself.',
    color: 'gold',
  },
];

const steps = [
  { num: '01', title: 'Fill the Form', desc: 'Share your NEET score, budget and destination preference in under 2 minutes.' },
  { num: '02', title: 'Get Your Roadmap', desc: 'Our counsellor calls within 24 hrs with a shortlist of matching colleges.' },
  { num: '03', title: 'Apply & Get Admitted', desc: 'We handle your application, documents and pre-departure prep.' },
];

const ApplicationForm = () => {
  const { openModal } = useModal();
  return (
  <section className="why-section" id="apply">
    <div className="why-inner">

      {/* ── Header ── */}
      <div className="why-hd reveal">
        <div className="sec-label">Why Choose Us</div>
        <h2 className="sec-title">Everything You Need,<br /><span className="why-grad">In One Place</span></h2>
        <p className="sec-sub why-hd-sub">
          We don’t just share a list of MBBS universities. We create a personalised MBBS abroad admission plan based on your NEET score, budget, and career goals.
        </p>
      </div>

      {/* ── 6 Reason Cards ── */}
      <div className="why-grid reveal">
        {reasons.map((r, i) => (
          <div className={`why-card why-card--${r.color}`} key={i}>
            <div className={`why-icon why-icon--${r.color}`}>{r.icon}</div>
            <h3 className="why-card-title">{r.title}</h3>
            <p className="why-card-desc">{r.desc}</p>
          </div>
        ))}
      </div>

      {/* ── How It Works strip ── */}
      <div className="why-process reveal">
        <div className="why-process-label">Simple 3-Step Process</div>
        <div className="why-steps">
          {steps.map((s, i) => (
            <React.Fragment key={i}>
              <div className="why-step">
                <div className="why-step-num">{s.num}</div>
                <div className="why-step-body">
                  <div className="why-step-title">{s.title}</div>
                  <div className="why-step-desc">{s.desc}</div>
                </div>
              </div>
              {i < steps.length - 1 && <div className="why-step-arrow">→</div>}
            </React.Fragment>
          ))}
        </div>
        <div className="why-process-cta">
          <button onClick={openModal} className="why-cta-btn">Start Free Counselling →</button>
          <span className="why-cta-note">🔒 Free · No Obligation · 24-hr Response</span>
        </div>
      </div>

    </div>
  </section>
  );
};

export default ApplicationForm;